import { Eye } from "lucide-react";
import { fmt, fmtDate } from "../../lib/format";
import { T } from "../../ui/tokens";
import type { MovimentoExtrato } from "./types";

interface Props {
  movimentos: MovimentoExtrato[];
  movimentoAtual: MovimentoExtrato;
  onAbrirOriginal?: () => void;
}

export default function ExtratoTabelaPreview({ movimentos, movimentoAtual, onAbrirOriginal }: Props) {
  const movimentosDoFicheiro = movimentos.filter((movimento) => {
    if (movimentoAtual.importacao_id) return movimento.importacao_id === movimentoAtual.importacao_id;
    return movimento.banco === movimentoAtual.banco && movimento.conta === movimentoAtual.conta;
  });
  const linhas = movimentosDoFicheiro.length ? movimentosDoFicheiro : [movimentoAtual];

  return (
    <div style={{ height: "100%", minHeight: 0, display: "flex", flexDirection: "column", background: T.surface }}>
      <div style={{ padding: "9px 12px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, borderBottom: `1px solid ${T.border}` }}>
        <div>
          <div style={{ fontSize: 11.5, fontWeight: 800, color: T.text }}>Movimentos do extrato</div>
          <div style={{ fontSize: 10.5, color: T.textLight, marginTop: 2 }}>{linhas.length} linha{linhas.length === 1 ? "" : "s"} importada{linhas.length === 1 ? "" : "s"}</div>
        </div>
        {onAbrirOriginal && (
          <button
            type="button"
            onClick={onAbrirOriginal}
            style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "6px 9px", border: `1px solid ${T.border}`, borderRadius: 7, background: T.surface, color: T.textMid, fontSize: 10.5, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}
          >
            <Eye size={12} /> Abrir original
          </button>
        )}
      </div>
      <div style={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11.5 }}>
          <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
            <tr style={{ background: T.bg, color: T.textLight, textAlign: "left" }}>
              <th style={cabecalho}>Data</th>
              <th style={cabecalho}>Descrição</th>
              <th style={{ ...cabecalho, textAlign: "right" }}>Valor</th>
              <th style={{ ...cabecalho, textAlign: "right" }}>Saldo</th>
            </tr>
          </thead>
          <tbody>
            {linhas.map((movimento) => {
              const atual = movimento.id === movimentoAtual.id;
              return (
                <tr key={movimento.id} style={{ background: atual ? T.blueBg : T.surface, borderBottom: `1px solid ${T.borderSoft}` }}>
                  <td style={{ ...celula, whiteSpace: "nowrap", color: T.textMid }}>{fmtDate(movimento.data_mov)}</td>
                  <td style={{ ...celula, color: T.text, fontWeight: atual ? 800 : 500 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      {atual && <span style={{ width: 6, height: 6, borderRadius: "50%", background: T.blue, flexShrink: 0 }} />}
                      <span>{movimento.descricao || "—"}</span>
                    </div>
                  </td>
                  <td style={{ ...celula, textAlign: "right", whiteSpace: "nowrap", fontWeight: 750, color: movimento.valor < 0 ? T.red : T.green }}>{fmt(movimento.valor)}</td>
                  <td style={{ ...celula, textAlign: "right", whiteSpace: "nowrap", color: T.textMid }}>{movimento.saldo == null ? "—" : fmt(movimento.saldo)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const cabecalho: React.CSSProperties = {
  padding: "8px 10px", borderBottom: `1px solid ${T.border}`, fontSize: 9.5,
  fontWeight: 800, letterSpacing: ".05em", textTransform: "uppercase", whiteSpace: "nowrap",
};

const celula: React.CSSProperties = {
  padding: "8px 10px", verticalAlign: "top", lineHeight: 1.35,
};
